export const TIMETABLE = {
  ROOT: '/timetable',
  APARTMENTS: '/timetable/apartments',
  APARTMENTS_MANAGERS: '/timetable/apartments/managers',
  APARTMENTS_PROJECTS: '/timetable/apartments/projects',
};
